import { validateAvailableTimes } from 'components/practice/Settings/components/PracticeDetails/lib/workingHoursUtils';

const parseAvailableTimes = (raw) => {
  let parsed = raw;
  if (typeof parsed === 'string') {
    try {
      parsed = JSON.parse(parsed);
    } catch {
      parsed = null;
    }
  }
  return Array.isArray(parsed) ? parsed : null;
};

export const getInviteMemberInitialValues = (member) => ({
  f_name: member?.f_name || '',
  m_name: member?.m_name || '',
  l_name: member?.l_name || '',
  role: member?.role_id || null,
  profession_group_id: member?.profession_group_id || null,
  gender: member?.gender || null,
  email: member?.email || '',
  dob: member?.dob || '',
  color: member?.color || '',
  phone: member?.phone || '',
  npi: member?.claimMdInfo?.npi || '',
  tax_id: member?.claimMdInfo?.tax_id || '',
  tax_id_type: member?.claimMdInfo?.tax_id_type || '',
  taxonomy: member?.claimMdInfo?.taxonomy || '',
  address: member?.address?.address_ln_1 || '',
  address_2: member?.address?.address_ln_2 || '',
  city: member?.address?.city || '',
  state: member?.address?.state || '',
  zip: member?.address?.zip || '',
  payment_rate: member?.payment_rate ? (member.payment_rate / 100).toFixed(2) : '0',
  is_active: member?.status === 'active',
  local_state_ids: Array.isArray(member?.local_state_ids) ? member.local_state_ids : [],
  virtual_state_ids: Array.isArray(member?.virtual_state_ids) ? member.virtual_state_ids : [],
  availableTimes: parseAvailableTimes(member?.available_times)
});

// Returns null when validation passes, otherwise a single human-readable message
// joining all per-day errors from validateAvailableTimes.
export const checkAvailableTimesError = (availableTimes) => {
  if (!Array.isArray(availableTimes) || availableTimes.length === 0) return null;
  const { hasError, errors } = validateAvailableTimes(availableTimes);
  if (!hasError) return null;

  if (errors && typeof errors === 'object') {
    const errorList = [];
    Object.entries(errors).forEach(([day, errObj]) => {
      if (!errObj) return;
      if (errObj.breaks) {
        Object.values(errObj.breaks).forEach((msg) => errorList.push(`${day}: ${msg}`));
      }
      if (errObj.virtual) errorList.push(`${day}: ${errObj.virtual}`);
      if (errObj.location) errorList.push(`${day}: ${errObj.location}`);
    });
    if (errorList.length > 0) return errorList.join(', ');
  }
  return 'Please fix the errors in your availability times.';
};
